import React from "react";
import { Result, Button } from "antd";

function SuccessForm({ title, subTitle, flag, backEvent }) {
  return (
    <Result
      status="success"
      title={title} //"Successfully Purchased Contract!"
      subTitle={subTitle} //"Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
      extra={
        flag && (
          <Button type="primary" key="console" onClick={backEvent}>
            Back
          </Button>
        )
      }
    />
  );
}

export { SuccessForm };
